import { render, staticRenderFns } from "./PopupOrganization.vue?vue&type=template&id=70aa84bc&"
import script from "./PopupOrganization.vue?vue&type=script&lang=js&"
export * from "./PopupOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports